import { render, staticRenderFns } from "./CommonPetitionerListModalDetail.vue?vue&type=template&id=25892681&"
import script from "./CommonPetitionerListModalDetail.ts?vue&type=script&lang=ts&"
export * from "./CommonPetitionerListModalDetail.ts?vue&type=script&lang=ts&"
import style0 from "./CommonPetitionerListModalDetail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports